import { Box, Grid } from '@mui/material';
import { memo } from 'react';
import { ChatParticipant } from '../../types/chat.types';
import ChatParticipantList from './ChatParticipantList';
import ChatParticipantsSearch from './ChatParticipantsSearch';

type ChatParticipantListContainerProps = {
  multiselect: boolean;
  isLoading: boolean;
  participants: ChatParticipant[];
  selectedParticipantsLength: number;
  loadMoreRows: () => void;
  changeQuery: (value: string) => void;
  onClick: (participant: ChatParticipant) => void;
};

const ChatParticipantListContainer = ({
  participants,
  multiselect,
  isLoading,
  selectedParticipantsLength,
  loadMoreRows,
  changeQuery,
  onClick,
}: ChatParticipantListContainerProps) => {
  return (
    <Grid container direction="column" style={{ height: '100%' }}>
      <Grid>
        <Box
          sx={{
            px: '16px',
            py: '12px',
          }}
        >
          <ChatParticipantsSearch onChange={changeQuery} />
        </Box>
      </Grid>
      <Grid size="grow">
        <ChatParticipantList
          multiselect={multiselect}
          isLoading={isLoading}
          loadMore={loadMoreRows}
          participants={participants}
          onClick={onClick}
          selectedParticipantsLength={selectedParticipantsLength}
        />
      </Grid>
    </Grid>
  );
};

export default memo(ChatParticipantListContainer);
